import { render, staticRenderFns } from "./CuponesList.partials.vue?vue&type=template&id=642ab856&"
import script from "./CuponesList.partials.vue?vue&type=script&lang=js&"
export * from "./CuponesList.partials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports